import FormController, { type ManagedForm } from "./FormController";

const formController = new FormController();

type FormsStore = {
    items: Record<string, ManagedForm>;
    get(id: string): ManagedForm | undefined;
    getHtml(id: string): string;
    getMessage(id: string): string;
    isSubmitting(id: string): boolean;
    isSubmitted(id: string): boolean;
    isError(id: string): boolean;
    submit(id: string): Promise<unknown>;
};

const formsStore: FormsStore = {
    items: formController.getAll(),

    get(id: string) {
        return this.items[id];
    },

    getHtml(id: string) {
        const form = this.get(id);

        if (
            form?.response &&
            typeof form.response === "object" &&
            "html" in form.response &&
            typeof form.response.html === "string"
        ) {
            return form.response.html;
        }

        return "";
    },

    isSubmitting(id: string) {
        const form = this.get(id);
        return form?.status === "submitting";
    },

    isSubmitted(id: string) {
        const form = this.get(id);
        return form?.status === "submitted-success";
    },

    isError(id: string) {
        const form = this.get(id);
        return form?.status === "submitted-error" || form?.status === "validation-error";
    },

    submit(id: string) {
        return formController.submit(id);
    },

    getMessage(id: string) {
        const form = this.get(id);

        if (!form) {
            return "";
        }

        return form.errors[0] ?? "";
    },
};

document.addEventListener("alpine:init", () => {
    Alpine.store("forms", formsStore);

    formController.subscribe(() => {
        const store = Alpine.store("forms") as FormsStore;

        store.items = {
            ...formController.getAll(),
        };
    });
});